import { useEffect } from 'react';
import { useFeatureCheck } from './useQueries';
import { setV2UploadsEnabled } from '../utils/featureFlags';

/**
 * Hook to check feature access using the existing feature toggle API
 * 
 * Supports three audience types:
 * - __ALL__: Feature enabled for everyone
 * - __SUPER_ADMIN__: Feature enabled only for super admins
 * - Group ID: Feature enabled only for users in that specific group
 * 
 * @returns Object with feature access checks
 */
export function useFeatureFlags() {
  const groupsQuery = useFeatureCheck('groups');
  const invitesQuery = useFeatureCheck('invites');
  const collectionsQuery = useFeatureCheck('collections');
  const v2UploadsQuery = useFeatureCheck('v2_uploads');

  const loading = groupsQuery.isLoading || invitesQuery.isLoading || collectionsQuery.isLoading || v2UploadsQuery.isLoading;

  useEffect(() => {
    if (v2UploadsQuery.data?.enabled !== undefined) {
      setV2UploadsEnabled(v2UploadsQuery.data.enabled);
    }
  }, [v2UploadsQuery.data?.enabled]);

  return {
    canAccessGroups: groupsQuery.data?.enabled !== false,
    canAccessInvites: invitesQuery.data?.enabled !== false,
    canAccessCollections: collectionsQuery.data?.enabled !== false,
    v2Uploads: v2UploadsQuery.data?.enabled === true,
    loading,
  };
}
